import { Component, input } from '@angular/core';
import { IconColorVariant, IconComponent } from '../icon/icon.component';
import { TooltipDirective } from '../../directives/tooltip/tooltip.directive';

/**
 * Wiederverwendbare KPI-/Kennzahl-Kachel auf Basis von `work-card`.
 * Zeigt links ein Icon, rechts davon Label (oben) und Wert (unten) untereinander.
 *
 * Beispiel:
 * ```html
 * <work-ui-stat-card iconName="bolt" [label]="'TICKET_AVG_REACTION_TIME' | translate" [value]="reactionTimeDisplay()" />
 * ```
 */
@Component({
  selector: 'work-ui-stat-card',
  standalone: true,
  imports: [IconComponent, TooltipDirective],
  templateUrl: './stat-card.component.html',
  styleUrls: ['./stat-card.component.scss'],
})
export class StatCardComponent {
  /** Bereits übersetzter Beschriftungstext (z.B. „Durchschnittliche Reaktionszeit"). */
  public readonly label = input.required<string>();
  /** Anzuzeigender Wert als String (z.B. „22.1 Std."). */
  public readonly value = input.required<string>();
  /** Material-Symbol-Name des links dargestellten Icons. */
  public readonly iconName = input.required<string>();
  /** Farbvariante des Icons. */
  public readonly iconTheme = input<IconColorVariant>('primary');
  /** Optionaler, bereits übersetzter Hilfetext: zeigt ein Info-Icon neben dem Label mit Tooltip. */
  public readonly infoText = input<string | undefined>(undefined);
}
